export default __webpack_public_path__ + "ce5ce0eeef856ef6b81353b88e8fc2b5.jpg";